import React, { useState } from 'react';
import HeaderWithBack from '../../components/HeaderWithBack';
import { useNavigate } from 'react-router';
import {toast} from "react-toastify";
import {CategoryDTO} from "../../dtos/category.dto";
import {useRecoilValue} from "recoil";
import {fetchAPIResponseSelector} from "../../store/user.atom";
import {IngredientDTO} from "../../dtos/ingredient.dto";

type Props = {};

const AddIngredient: React.FC<Props> = () => {
  const navigate = useNavigate();

  const fetchAPIResponse = useRecoilValue(fetchAPIResponseSelector);
  const [ingredientName, setIngredientName] = useState<string>('');
  const [ingredientPrice, setIngredientPrice] = useState<string>('');

  const handleAddIngredient = async () => {
    if(ingredientName === '' || ingredientPrice === '') {
      toast.error("Fill in contents before creating the ingredient")
      return;
    }

    try {
      await fetchAPIResponse<IngredientDTO>("/ingredients", {
        method: "POST",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          name: ingredientName,
          base_price: Number(ingredientPrice)
        })
      });

      navigate('/ingredients')
    } catch (e) {
      toast.error((e as Error).message)
    }
  };

  return (
    <div className='flex flex-col w-full h-full overflow-auto items-center py-10 gap-6'>
      <HeaderWithBack previousPage={'Ingredients'} currentPage={'Add Ingredient'} previousPageUrl={'/ingredients'} />
      <div className='zbh-card w-11/12 max-w-2xl p-8'>
        <h2 className="font-display text-base font-semibold text-ink mb-5">New ingredient</h2>
        <div className="space-y-4">
          <div>
            <label className="zbh-label">Name</label>
            <input type='text' placeholder='e.g. Cheddar cheese' value={ingredientName}
              onChange={(e) => setIngredientName(e.target.value)} className='zbh-input' />
          </div>
          <div>
            <label className="zbh-label">Price ($)</label>
            <input type='text' placeholder='0.00' value={ingredientPrice}
              onChange={(e) => setIngredientPrice(e.target.value)} className='zbh-input' />
          </div>
        </div>
        <button onClick={handleAddIngredient} className='zbh-btn-accent w-full mt-6'>
          Add ingredient
        </button>
      </div>
    </div>
  );
};

export default AddIngredient;
